/**
 * 📦 V2 Products API client
 *
 * Mapeia rotas /api/v2/products do backend V2.
 * Doc do schema: docs/V2/04_MODELO_DADOS.md
 */

import v2Api from './index';

export const productsV2API = {
  /**
   * Cria um produto V2.
   * Payload mínimo: { name }
   * Campos opcionais: description, category, image_url, commission_type,
   *   commission_value_affiliate, commission_value_manager, commission_value_coproducer
   * user_id é inferido do JWT no backend.
   * Returns: { success: true, product }
   */
  create: (data) => v2Api.post('/products', data),

  /**
   * Lista produtos do usuário autenticado.
   * Query opcional: { limit, offset }
   */
  listMine: (params = {}) => v2Api.get('/products/me', { params }),

  /**
   * Busca produto por ID numérico.
   */
  findById: (id) => v2Api.get(`/products/${id}`),

  /**
   * Busca produto por UUID público.
   */
  findByUuid: (uuid) => v2Api.get(`/products/uuid/${uuid}`),

  /**
   * Atualiza campos parciais do produto.
   * Body: subset de { name, description, category, image_url, status, commission_type, commission_value_* }
   */
  update: (id, data) => v2Api.patch(`/products/${id}`, data),

  /**
   * Soft-delete.
   */
  remove: (id) => v2Api.delete(`/products/${id}`),
};

export default productsV2API;
